<template>
  <div
    class="min-h-screen min-w-screen flex flex-col justify-between"
  >
    <div>
      <main
        container="padded base"
      >
        <slot />
      </main>
    </div>

    <LazyAppFooter />
  </div>
</template>
